export enum HTTP_STATUS_CODE {
  OK = 200,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  GONE = 410,
  UNEXPECTED_ERROR = 500,
}

export enum HTTP_HEADER_NAME {
  ACCEPT = 'Accept',
  CONTENT_TYPE = 'Content-Type',
  AUTHORIZATION = 'Authorization',
  CACHE_CONTROL = 'Cache-Control',
}

export enum HTTP_CONTENT_TYPE {
  JSON = 'application/json',
  X_WWW_FORM_URLENCODED = 'application/x-www-form-urlencoded',
  FORM_DATA = 'multipart/form-data',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

export enum HTTP_RESPONSE_TYPE {
  BLOB = 'blob',
}

export enum HTTP_CACHE_CONTROL {
  NO_CACHE = 'no-cache',
}

export enum HTTP_METHOD {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}
